import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space8 } = theme();

  return StyleSheet.create({
    buttonCTA: {
      width: "100%",
    },
    largeOuterWrapper: {
      width: 400, // L y M
    },
    outerWrapper: {
      alignItems: "center",
      alignSelf: "center",
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      paddingHorizontal: space8,
    },
    title: {
      marginBottom: space8,
    },
    titleArea: {
      marginBottom: space8,
    },
  });
};

export { style };
